import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import "../../styles/FAQs.scss"

const Herosection = ({ title }) => {
  return (
    <section id="commmunity-hero-section">
      <Container>
        <Row className=" justify-content-center">
          <Col md={10} className="text-center">
            <div className="title-txt">{title}</div>
            <h1>Get Connected with People on Rehabilitation Journey</h1>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Herosection
